import { SYDNEY_TIME_ZONE } from "@/lib/utils";

export function formatDateLabel(value?: string | null) {
  if (!value) return "Date TBA";
  return new Intl.DateTimeFormat("en-AU", {
    weekday: "short",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: SYDNEY_TIME_ZONE
  }).format(new Date(value));
}

export function formatShortDate(value?: string | null) {
  if (!value) return "TBA";
  return new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    timeZone: SYDNEY_TIME_ZONE
  }).format(new Date(value));
}

export function formatTimeRange(start?: string | null, end?: string | null) {
  if (!start) return "Time TBA";
  const formatter = new Intl.DateTimeFormat("en-AU", {
    hour: "numeric",
    minute: "2-digit",
    timeZone: SYDNEY_TIME_ZONE
  });
  const startLabel = formatter.format(new Date(start));
  return end ? `${startLabel} - ${formatter.format(new Date(end))}` : startLabel;
}

export function formatDealWindow(start?: string | null, end?: string | null) {
  if (!start && !end) return "Available now";
  if (start && end) return `${formatShortDate(start)} - ${formatShortDate(end)}`;
  if (start) return `From ${formatShortDate(start)}`;
  return `Ends ${formatShortDate(end)}`;
}

export function firstSentence(value?: string | null, fallback = "Neighbourhood Voice local pick.") {
  const trimmed = value?.trim();
  if (!trimmed) return fallback;
  const match = trimmed.match(/^(.+?[.!?])\s/);
  return match?.[1] ?? trimmed;
}

export function imageForIndex(paths: string[], index: number) {
  return paths[index % paths.length] ?? null;
}
